import createCssClass from './createCssClass';

export function createTpxPlayerClass() {
  const className = '.tpx-player-editorial';
  const styles =
    'position: relative;padding-bottom: 56.25% !important;height: 0;overflow: hidden;max-width: 100% !important;';
  createCssClass(className, styles);
}
export function createTpxPlayerIframeClass() {
  const className = '.tpx-player-editorial iframe';
  const styles = '  position: absolute; top: 0; left: 0;min-width: 100%;width: 1px;height: 100%;';
  createCssClass(className, styles);
}

export default function createCssClasses() {
  createTpxPlayerClass();
  createTpxPlayerIframeClass();
}
